export interface IExponentialBackOffOptions {
  isFirstAttepmtDelayed: boolean
  maximumDelay: number
  numberOfAttempts: number
  retry: (e: any, attemptNumber: number) => boolean | Promise<boolean>
  startingDelay: number
  exponentialTime: number
}

const defaultOptions: IExponentialBackOffOptions = {
  isFirstAttepmtDelayed: false,
  maximumDelay: Infinity,
  numberOfAttempts: 10,
  retry: () => true,
  startingDelay: 100,
  exponentialTime: 2,
}

export const getOptionsSanitized = (
  options: Partial<IExponentialBackOffOptions>,
) => {
  const optionsSanitized: IExponentialBackOffOptions = {
    ...defaultOptions,
    ...options,
  }

  if (optionsSanitized.numberOfAttempts < 1) {
    optionsSanitized.numberOfAttempts = 1
  }

  return optionsSanitized
}
